import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

import DoorAccessFormDialog from './DoorAccessFormDialogContainer'
import EditIconButton from '../controls/buttons/EditIconButton'
import StatusEnabledDisabled from '../controls/StatusEnabledDisabled'
import DeleteUsersButton from './DeleteUsersButton'

class DoorAccessDetailsContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    classes: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    /* passed props */
    accessId: PropTypes.number.isRequired,
    /* mapped state */
    doorAccesses: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      doorAccesses: state.doorAccesses,
    }
  }

  static styles = () => ({
    toolbar: {
      minHeight: 0,
      padding: 0,
    },
    toolbarControls: {
      flex: '1',
      textAlign: 'right',
    },
    table: {
      '& th:last-child': {
        textAlign: 'right',
        paddingRight: 10,
      },
      '& td:last-child': {
        textAlign: 'right',
        paddingRight: 0,
      },
    },
  })

  state = {
    openDialog: false,
  }

  handleEditClick = () => {
    this.setState({ openDialog: true })
  }

  handleDialogClose = () => {
    this.setState({ openDialog: false })
  }

  handleDeleteComplete = (communityId) => {
    this.props.history.push(`/communities/${communityId}`)
  }

  renderCredential = (cred, index) => {
    const credParts = []
    const isCombo = cred.card !== '' && cred.pin !== ''

    if (cred.card !== '') {
      credParts.push(`Card: ${cred.card}`)
    }

    if (isCombo) {
      credParts.push(<strong key={`cred-delimeter-${index}`}> AND </strong>)
    }

    if (cred.pin !== '') {
      credParts.push(`PIN: ${cred.pin}`)
    }

    return (
      <TableRow key={`cred-${index}`}>
        <TableCell>
          {credParts}
        </TableCell>
        <TableCell>
          <StatusEnabledDisabled enabled={cred.enabled} showText />
        </TableCell>
      </TableRow>
    )
  }

  doorAccess() {
    return this.props.doorAccesses[this.props.accessId] || {}
  }

  render() {
    const { classes } = this.props
    const doorAccess = this.doorAccess()
    const credentials = doorAccess.credentials || []
    const username = doorAccess.name
    const accessId = doorAccess.id
    const communityId = doorAccess.parent_community_id

    if (accessId) {
      return (
        <>
          <Toolbar className={classes.toolbar}>
            <Typography variant="h6">
              {username}
            </Typography>
            <div className={classes.toolbarControls}>
              <EditIconButton onClick={this.handleEditClick} tooltipTitle={`Edit ${username}`} />
              <DeleteUsersButton
                accessIds={[accessId]}
                communityId={communityId}
                tooltipTitle={`Delete ${username}`}
                onDeleteComplete={() => { this.handleDeleteComplete(communityId) }}
              />
            </div>
          </Toolbar>
          <div>
            Status: <StatusEnabledDisabled enabled={doorAccess.enabled} showText />
          </div>

          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Access Credentials</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {credentials.map(this.renderCredential)}
            </TableBody>
          </Table>

          <DoorAccessFormDialog
            accessId={accessId}
            communityId={communityId}
            onClose={this.handleDialogClose}
            open={this.state.openDialog}
          />
        </>
      )
    }

    return null
  }
}

export default connect(
  DoorAccessDetailsContainer.mapStateToProps,
)(withStyles(DoorAccessDetailsContainer.styles)(withRouter(DoorAccessDetailsContainer)))
